import React from "react";
import { beforeAfterGallery } from "../data/mock";
import { Sparkles } from "lucide-react";

const Gallery = () => {
  // Placeholder images for before/after demonstrations
  const galleryImages = [
    {
      before:
        "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=400&q=80",
      after:
        "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=400&q=80",
      title: "Teeth Whitening",
    },
    {
      before:
        "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=400&q=80",
      after:
        "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=400&q=80",
      title: "Smile Makeover",
    },
  ];

  return (
    <section className="section-padding-small bg-[#F5F5F4]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-20 px-2 sm:px-0">
          <div className="flex items-center justify-center gap-4 mb-4 sm:mb-6">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#FAFAF9] flex items-center justify-center">
              <Sparkles
                className="w-5 h-5 sm:w-6 sm:h-6 text-[#B45309]"
                strokeWidth={1.5}
              />
            </div>
          </div>
          <h2 className="heading-1 text-[#1C1917] mb-4 sm:mb-6">
            Beautiful Smile Transformations
          </h2>
          <p className="body-large text-[#57534E] text-sm sm:text-base">
            Dr. Dabbous has transformed smiles for many years, taking pride in a
            meticulous approach to cosmetic dentistry.
          </p>
        </div>

        {/* Before/After Grid */}
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 max-w-5xl mx-auto px-2 sm:px-0">
          {galleryImages.map((item, index) => (
            <div
              key={index}
              className="bg-[#FFFFFF] overflow-hidden rounded-lg shadow-refined hover-lift border border-[#E7E5E4]"
            >
              <div className="p-4 sm:p-6 lg:p-8">
                <h3 className="heading-3 text-[#1C1917] mb-4 sm:mb-6 text-center text-sm sm:text-base">
                  {item.title}
                </h3>

                <div className="grid grid-cols-2 gap-4 sm:gap-6">
                  {/* Before */}
                  <div className="space-y-2 sm:space-y-3">
                    <p className="body-small text-[#78716C] text-center uppercase tracking-wider font-medium text-xs">
                      Before
                    </p>
                    <div className="overflow-hidden rounded-md border-2 border-[#E7E5E4]">
                      <img
                        src={item.before}
                        alt={`${item.title} - Before`}
                        className="w-full h-40 sm:h-52 object-cover transition-transform duration-700 hover:scale-105"
                      />
                    </div>
                  </div>

                  {/* After */}
                  <div className="space-y-2 sm:space-y-3">
                    <p className="body-small text-[#0F766E] text-center uppercase tracking-wider font-medium text-xs">
                      After
                    </p>
                    <div className="overflow-hidden rounded-md border-2 border-[#0F766E]">
                      <img
                        src={item.after}
                        alt={`${item.title} - After`}
                        className="w-full h-40 sm:h-52 object-cover transition-transform duration-700 hover:scale-105"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 sm:mt-16 px-2 sm:px-0">
          <p className="body-large text-[#57534E] mb-6 sm:mb-8 max-w-xl mx-auto text-sm sm:text-base">
            Ready to transform your smile with our expert cosmetic dentistry?
          </p>
          <button
            onClick={() => {
              const element = document.getElementById("appointments");
              if (element) element.scrollIntoView({ behavior: "smooth" });
            }}
            className="btn-primary text-xs sm:text-sm px-4 sm:px-8"
          >
            Book a Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
